package com.appcreator.client.firebase.auth

import androidx.compose.runtime.Composable
import com.appcreator.blueprint.core.EnvStore
import com.appcreator.blueprint.firebase.auth.FirebaseAuthSignInWithApple
import com.appcreator.compose.actions.Performer
import com.appcreator.compose.di.Container
import com.appcreator.compose.events.LoginEvent
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.auth.externals.OAuthProvider
import dev.gitlive.firebase.auth.externals.signInWithPopup
import dev.gitlive.firebase.auth.js
import kotlin.coroutines.resume
import kotlin.coroutines.resumeWithException
import kotlin.coroutines.suspendCoroutine

@Composable
actual fun signInWithApplePerformerDeferred(action: FirebaseAuthSignInWithApple): Performer.Deferred {
    return object : Performer.Deferred {
        override suspend fun perform(envStore: EnvStore) {
            val provider = OAuthProvider("apple.com")
            provider.addScope("email")
            val result = suspendCoroutine { continuation ->
                signInWithPopup(Firebase.auth.js, provider)
                    .then {
                        continuation.resume(it.user)
                    }
                    .catch {
                        continuation.resumeWithException(it)
                    }
            }
            Container.sendEvent(LoginEvent(result.uid, result.email, result.displayName))
        }
    }
}
